import { useContext } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { createTheme, ThemeProvider } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';

type Props = {
  currentTab: string;
  items: {
    label: string;
    to: string;
    value: string;
  }[];
};

export const TabsContainer = ({ currentTab, items }: Props) => {

  const originalTheme = useTheme();
  const { palette, theme: wl } = useContext(AppThemingContext);

  const theme = createTheme({
    ...originalTheme,
    palette: {
      ...originalTheme.palette,
      primary: {
        ...originalTheme.palette.primary,
        main: wl?.enabled ? palette.primary.main : originalTheme.palette.hyperlink,
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ position: 'relative' }}>
        <Bar />
        <Tabs
          indicatorColor='primary'
          textColor='primary'
          value={currentTab}
          sx={({
            '& .MuiTabs-indicator': {
              height: '4px',
              position: 'absolute',
              bottom: 1,
              zIndex: 1,
            },
          })}>
          {items.map(item => (
            <StyledTab
              key={item.value}
              label={item.label}
              value={item.value}
              to={item.to} />
          ))}
        </Tabs>
      </Box>
      <Outlet />
    </ThemeProvider>
  );
};

const Bar = styled('div')({
  position: 'absolute',
  bottom: 1,
  width: '100%',

  height: '3px',
  backgroundColor: '#e5e5e5',
});

type TabProps = {
  label: string;
  value: string;
  to: string;
};

const StyledTab = (props: TabProps) => (
  <Tab
    {...props}
    disableRipple={true}
    component={Link}
    sx={theme => ({
      fontFamily: theme.fonts.bold,
      textTransform: 'none',
      fontSize: 16,
      width: 150,
      minHeight: 45,
    })}
  />
);